import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { TreeChild1 } from "../../redux/reducers/AssetReducer";

export const useGetPlatform = (id: String) => {
  let finish = false;
  let platform: TreeChild1 = {
    id: "",
    name: "",
    metadata: {"type": ""},
  };

  const treeData = useSelector((state: RootState) => state.asset.tree);
  const realTreeData = treeData.children!;

  for (let i = 0; i < realTreeData.length; i++) {
    if (finish) {
      break;
    }
    if (realTreeData[i].hasOwnProperty('children')) {
      for (let j = 0; j < realTreeData[i].children!.length; j++) {
        if (finish) {
          break;
        }
        if (realTreeData[i].children![j].hasOwnProperty('children')) {
          for (let k = 0; k < realTreeData[i].children![j].children!.length; k++) {
            if (finish) {
              break;
            }
            if (realTreeData[i].children![j].children![k].id === id) {
              platform = realTreeData[i].children![j].children![k];
              finish = true;
              break;
            }
          }
        }
      }
    }
  }

  return platform;
}
